"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isBasketPage = void 0;
const isBasketPage = () => window.location.pathname.includes('basket');
exports.isBasketPage = isBasketPage;